
















































import { Component, Vue } from 'vue-property-decorator'
import { GamificationSettingsAPI, UserAPI } from '@/api/backend-client'
import { GamificationSettings } from '@/api/model/gamification-settings'

@Component
export default class NavigationUser extends Vue {
    gamificationSettings: GamificationSettings = null

    async logout(): Promise<void> {
        if (confirm('Weet je zeker dat je wilt uitloggen?')) {
            await UserAPI.logout()
            window.location.href = `${ process.env.VUE_APP_ONE_APP_BASEURL }/logout`
        }
    }

    async mounted() {
        this.gamificationSettings = await GamificationSettingsAPI.get(this.$currentCompany.id, true)
    }

    get gamificationEnabled(): boolean {
        return this.gamificationSettings && this.gamificationSettings.enabled
    }
}

